<template>
  <v-row>
    <v-col v-if="!accountTemplatesLoading">
      <templates-template-list
        :title="templateListTitle"
        :templates="accountTemplates"
        :new-template-defaults="newTemplateDefaults"
      />
    </v-col>
  </v-row>
</template>
<script>
import TemplatesTemplateList from './TemplatesTemplateList.vue'

export default {
  name: 'TemplatesEditAccountTemplates',
  components: { TemplatesTemplateList },
  computed: {
    templateListTitle() {
      return `${this.account.shortName} account templates`
    },
    newTemplateDefaults() {
      return {
        accountId: this.account.id
      }
    }
  },
  async beforeCreate() {
    this.mapStates(['account', 'accountTemplates', 'accountTemplatesLoading'])
    await this.dispatchActions(['get_accountTemplates'])
  }
}
</script>
